<template>
  <div>
    <!-- menu header -->
    <v-card elevation="0" fixed tile>
      <v-app-bar flat color="rgba(0, 0, 0, 0)">
        <v-toolbar-title class="pl-0 all-menu-header">
          <icon-menu class="mr-3" />
          <span class="align-self-center">{{ $t('메뉴') }}</span>
        </v-toolbar-title>
        <v-spacer />

        <!-- 설정버튼 -->
        <v-btn @click="goSettingMenu" icon>
          <v-icon color="#363c43" size="24">mdi-cog-outline</v-icon>
        </v-btn>
      </v-app-bar>
    </v-card>

    <!-- menu list -->
    <v-list nav class="px-4 pb-4 overflow-y-auto" :style="scrollViewStyle">
      <menu-list-group
        class="all-menu-list"
        v-for="(item, index) in GET_MENU_LIST"
        v-bind:key="index"
        :categoryNm="item.categoryNm"
        :categoryCd="item.categoryCd"
        :menuList="item.menuList"
      />
    </v-list>
  </div>
</template>

<script>
/* 전체메뉴 */
import MenuListGroup from '@/components/menu/MenuListGroup.vue';
import IconMenu from '@/assets/customIcon/IconMenu.vue';
import { mapGetters } from 'vuex';
import routerConstants from '@/const/routerConstants';
import TabMenuMixin from '@/mixins/tabMenuMixin'; // ** tab menu Mixin **

export default {
  mixins: [TabMenuMixin],

  data: () => ({
    selectedItem: 1,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('MENU', ['GET_MENU_LIST']),
  },

  watch: {
    GET_MENU_LIST() {
      // +. 공통 스피너 OFF
      this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
    },
  },

  methods: {
    /* 설정메뉴 화면으로 이동 */
    goSettingMenu() {
      this.$router.push({ name: routerConstants.SettingMenu });
    },
  },

  mounted() {
    // 1. 접근시 state 초기화
    this.$store.commit('ELA/RESET_ELA_STATE');
    this.$store.commit('ELA/RESET_APPLICATION_STATE');
  },

  components: {
    MenuListGroup,
    IconMenu,
  },
};
</script>
